.noResults {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px;
	box-sizing: border-box;
}

.noResultsText {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
	font-size: 15px;
	font-weight: 400;
	color: black;
	text-align: center;
	max-width: 600px;
}
